module.exports = __webpack_public_path__ + "static/media/Prof. Dr. Khwaja Nazim Uddin.e8278217.png";